module.exports = __webpack_public_path__ + "fonts/raraya_font.a12d4227.eot";